const listeners = new Set();
let unreachable = false;

function notify() {
  listeners.forEach((listener) => listener(unreachable));
}

export function subscribeApiReachability(listener) {
  listeners.add(listener);
  listener(unreachable);
  return () => listeners.delete(listener);
}

export function isApiUnreachable() {
  return unreachable;
}

export function reportApiSuccess() {
  if (!unreachable) return;
  unreachable = false;
  notify();
}

export function reportApiNetworkFailure() {
  if (unreachable) return;
  unreachable = true;
  notify();
}

export function resetApiReachability() {
  unreachable = false;
  notify();
}
